import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function LoadingScreen({ onComplete }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onComplete, 700);
    }, 1500);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="fixed inset-0 z-[200] flex items-center justify-center"
          style={{ background: "#050510" }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <motion.div
            className="text-center"
            initial={{ opacity: 0, scale: 0.85 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <motion.div
              className="text-[7rem] font-light text-[#C9A84C] leading-none mb-2"
              style={{
                fontFamily: "Cormorant Garamond, serif",
                textShadow: "0 0 60px rgba(201,168,76,0.45)",
              }}
              animate={{ opacity: [1, 1, 0.7, 1] }}
              transition={{ duration: 1.5, times: [0, 0.5, 0.8, 1] }}
            >
              A
            </motion.div>
            <motion.p
              className="text-[0.65rem] uppercase tracking-[0.6em] text-[#9A9A9A]"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.6 }}
            >
              AURALIA
            </motion.p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
